import React from 'react';

/**
 * <Panel title="Recent Scans" subtitle="Last 7 days" accent="var(--cyan)" actions={<Button .../>}>
 *   {children}
 * </Panel>
 *
 * A titled section container with a gradient accent bar — used for dashboard panels.
 * `plain` drops the accent bar for a flat card-header look (.ui-panel--plain).
 */
export default function Panel({
  title,
  subtitle,
  accent = 'var(--accent)',
  accentSecondary,
  actions,
  children,
  noPadding = false,
  plain = false,
  className = '',
  style,
  ...rest
}) {
  const gradientAccent = accentSecondary
    ? `linear-gradient(135deg, ${accent}, ${accentSecondary})`
    : accent;

  return (
    <section
      className={`ui-panel ${plain ? 'ui-panel--plain ' : ''}${className}`}
      style={style || undefined}
      {...rest}
    >
      {(title || actions) && (
        <header className="ui-panel-header">
          {title && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <h2 style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--sp-2)',
                fontSize: plain ? 'var(--fs-base)' : 'var(--fs-sm)',
                fontWeight: 'var(--fw-bold)',
                color: 'var(--text-primary)',
                margin: 0,
                letterSpacing: '-0.01em',
              }}>
                {!plain && (
                  <span
                    aria-hidden
                    style={{
                      width: 3,
                      height: 14,
                      borderRadius: 2,
                      flexShrink: 0,
                      background: gradientAccent,
                      boxShadow: `0 0 8px ${accent}55`,
                    }}
                  />
                )}
                {title}
              </h2>
              {subtitle && (
                <span style={{
                  fontSize: 'var(--fs-xs)',
                  color: 'var(--text-muted)',
                  fontFamily: 'var(--font-mono)',
                  paddingLeft: plain ? 0 : 11,
                }}>
                  {subtitle}
                </span>
              )}
            </div>
          )}
          {actions && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)', flexShrink: 0 }}>
              {actions}
            </div>
          )}
        </header>
      )}
      {children && (
        <div style={noPadding ? undefined : { padding: 'var(--sp-5)' }}>
          {children}
        </div>
      )}
    </section>
  );
}
